import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0045859a")

_pushScopeId("data-v-0045859a")
const _hoisted_1 = { class: "py-20" }
const _hoisted_2 = {
  key: 0,
  class: "c-tip f-sm px-16 df-middle"
}
const _hoisted_3 = { class: "px-12" }
const _hoisted_4 = { class: "df-middle t-left fill" }
const _hoisted_5 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_DemoAccountTip = _resolveComponent("DemoAccountTip")
  const _component_QuoteBar = _resolveComponent("QuoteBar")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tab = _resolveComponent("Tab")
  const _component_TheTradeTargetPrice = _resolveComponent("TheTradeTargetPrice")
  const _component_TheTradeProducts = _resolveComponent("TheTradeProducts")
  const _component_TheTradeMethod = _resolveComponent("TheTradeMethod")
  const _component_Line = _resolveComponent("Line")
  const _component_TheTradeLimits = _resolveComponent("TheTradeLimits")
  const _component_TheTradeCost = _resolveComponent("TheTradeCost")
  const _component_Button = _resolveComponent("Button")
  const _component_TheCommissionCreateButton = _resolveComponent("TheCommissionCreateButton")
  const _component_ThePositionCreateButton = _resolveComponent("ThePositionCreateButton")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, {
    class: "create",
    "use-footer": ""
  }, {
    title: _withId(() => [
      _createVNode(_component_t, {
        path: _ctx.title.label,
        class: "f-lg"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title.labelDefault), 1)
        ]),
        _: 1
      }, 8, ["path"])
    ]),
    header: _withId(() => [
      _createVNode(_component_DemoAccountTip)
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_TheTradeCost, {
            symbol: _ctx.symbol,
            type: _ctx.type,
            isCommission: _ctx.isCommission
          }, null, 8, ["symbol", "type", "isCommission"])
        ]),
        _createVNode(_component_Button, {
          class: "line mr-10",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withId(() => [
            _createVNode(_component_t, {
              path: "placeorder_18",
              custom: ""
            }, {
              default: _withId(({ td }) => [
                _createTextVNode(_toDisplayString(td || 'Cancel'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.isCommission)
          ? (_openBlock(), _createBlock(_component_TheCommissionCreateButton, {
              key: 0,
              class: [_ctx.themeClass]
            }, null, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_ThePositionCreateButton, {
              key: 1,
              class: [_ctx.themeClass]
            }, null, 8, ["class"]))
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_QuoteBar, {
          symbol: _ctx.symbol,
          class: "px-12 bg-white py-4"
        }, null, 8, ["symbol"]),
        (_ctx.sepcialType === _ctx.ESpecialType.DOUBLE)
          ? (_openBlock(), _createBlock("p", _hoisted_2, [
              _createVNode(_component_Icon, {
                name: "help",
                class: "mr-4",
                sm: ""
              }),
              _createVNode(_component_t, {
                path: "placeorder_51",
                args: { code: _ctx.contractCode },
                as: "p",
                style: {"font-style":"oblique"}
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.contractCode) + " will automatically close the position by the end of the day. ", 1)
                ]),
                _: 1
              }, 8, ["args"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_t, { custom: "" }, {
            default: _withId(({ td, t }) => [
              _createVNode(_component_Tab, {
                tabs: [t('placeorder_2') || 'Market Order', t('placeorder_3') || 'Limit Order'],
                onSwitch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCommission = !_ctx.isCommission))
              }, null, 8, ["tabs"])
            ]),
            _: 1
          }),
          (_ctx.isCommission)
            ? (_openBlock(), _createBlock(_component_TheTradeTargetPrice, {
                key: 0,
                class: "mb-32 mt-24"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_TheTradeProducts, {
            code: _ctx.code,
            class: "my-24",
            paymethod: _ctx.paymethod
          }, null, 8, ["code", "paymethod"]),
          _createVNode(_component_TheTradeMethod, {
            method: _ctx.paymethod,
            "onUpdate:method": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paymethod = $event)),
            show: !_ctx.isCommission,
            uncredit: _ctx.unCredit,
            credit: _ctx.credit
          }, null, 8, ["method", "show", "uncredit", "credit"]),
          _createVNode(_component_Line, { class: "mt-16" }),
          _createVNode(_component_TheTradeLimits, {
            symbol: _ctx.symbol,
            isCommission: _ctx.isCommission
          }, null, 8, ["symbol", "isCommission"])
        ])
      ])
    ]),
    _: 1
  }))
})